<template>
    <div class="post-box">
        <div class="post-content text-left">
            <h6 class="post-title">
                Destek
            </h6>
            <ul class="postBox-list">
                <li class="postBox-item">
                                <span>
                                    <i class="ti-angle-double-right"></i>
                                </span>
                    <a>Yardim (S.S.S)</a>
                </li>
                <li class="postBox-item">
                                <span>
                                    <i class="ti-angle-double-right"></i>
                                </span>
                    <a>Bahis Sozlugu</a>
                </li>
                <li class="postBox-item">
                                <span>
                                    <i class="ti-angle-double-right"></i>
                                </span>
                    <a>Musteri Hizmetleri</a>
                </li>
            </ul>
            <div class="btn">Müşteri hizmetleri</div>
            <div class="btn">Şimdi canlı destek!</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'supportInfo',
        data () {
            return {
                msg: ''
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/supportInfo.vue